import {
  ICreateOptionValue,
  IOptionInfo,
  IOptionValue,
  TDentalArch,
} from 'lib/types/clinic/projectTypes';

export const makeOptionInitialValue = (optionInfo: IOptionInfo) => {
  if (!optionInfo || Object.keys(optionInfo).length === 0) return {};

  return Object.keys(optionInfo)?.reduce((acc: ICreateOptionValue, optionKey: string) => {
    const optionItem: IOptionInfo = optionInfo[optionKey];
    const option = {
      [optionKey]: {
        value: 'defaultValue' in optionItem ? optionItem.defaultValue : optionItem.values[0].value,
        isSavedLast: optionItem.isSavedLast,
      },
    };

    return { ...acc, ...option };
  }, {} as ICreateOptionValue);
};

export function checkError(value: any) {
  if (value === undefined || Number.isNaN(value) || value === null) return true;

  return false;
}

export function convertLengthBytes(value: string) {
  return value.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
}

// 범위 매핑을 도와주는 유틸 함수
export function mapRange(
  value: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number,
) {
  // 입력값(value)이 inMin~inMax 범위를 벗어나면 적절히 clamp
  if (value < inMin) value = inMin;
  if (value > inMax) value = inMax;

  // 선형 매핑 공식
  return outMin + ((value - inMin) * (outMax - outMin)) / (inMax - inMin);
}

export function getJawByToothNumber(toothNumber: number): TDentalArch | 'none' {
  if ((toothNumber >= 11 && toothNumber <= 18) || (toothNumber >= 21 && toothNumber <= 28)) {
    return 'upper';
  } else if ((toothNumber >= 31 && toothNumber <= 38) || (toothNumber >= 41 && toothNumber <= 48)) {
    return 'lower';
  } else {
    return 'none';
  }
}
